import * as React from 'react'
import Stack from '@mui/material/Stack'

import DataPalLogo from '~/client/components/DataPalLogo'

export default function Loading(props){
  {/* TODO: move this to an embeded SVG so we dont need to load an external asset */}
  return <Stack
    direction="row"
    alignItems="center"
    justifyContent="center"
    {...props}
  >
    <DataPalLogo size="xl" sx={{
      animation: 'LoadingPulse 2s alternate infinite',
      '@keyframes LoadingPulse': {
        from: {
          transform: 'scale(0.5)',
        },
        to: {
          transform: 'scale(1)',
        },
      }
    }}/>
  </Stack>
}
